import SentenceTable from "./SentenceTable";
import { ViewProps, sentence } from "shared/types/Report";
import useSentenceView from "features/homework/hooks/useSentenceView";
import { Button, ButtonReversed } from "shared/components/Button";
import Modal from "shared/components/Modal";
import LoadingWithProgressBar from "shared/components/Loading";
import FilePreviewModal from "shared/components/FilePreviewModal";
import SentenceBatchView from "./SentenceBatchView";
import { EditorShell, EditorHeader, EditorTitle, EditorDesc, ActionBar, ActionHint, CountBadge } from "../homeworkUi";

const SentenceView = ({list, path, setList}:ViewProps<sentence>) => {
    const {
        onAddClickHandler, 
        onChangeHandler, 
        onSelectHandler, 
        onSelectAllClickHandler, 
        selectedList, 
        onDeleteClickHandler, 
        isSaveSucceed, 
        onSuccessModalConfirmHandler, 
        onImageChangeHandler, 
        onImageInputClickHandler, 
        onRegisterReportClickHandler, 
        imageInputRefs, 
        uploadFileName, 
        progress, 
        showProgress, 
        selectedFile, 
        onDeleteImageClickHandler, 
        onFileModalCloseClickHandler, 
        onFileClickHandler, 
        isOpenBatchView, 
        onBatchViewCancelClickHandler, 
        onBatchViewOpenClickHandler, 
        audioInputRefs, 
        onAudioInputClickHandler, 
        onAudioChangeHandler,
        onAudioDeleteHandler
    } = useSentenceView(list, setList, path);
        const renderButtons = () => {
            if (selectedList.length) {
                return (
                    <ActionBar>
                        <ActionHint>선택한 {selectedList.length}개 항목을 삭제한 뒤 저장을 눌러 주세요</ActionHint>
                        <ButtonReversed name="삭제" onButtonClick={onDeleteClickHandler}/>
                    </ActionBar>
                );
            }
            return (
                <ActionBar>
                    <ButtonReversed name="일괄등록" onButtonClick={onBatchViewOpenClickHandler} />
                    <Button name="저장" onButtonClick={onRegisterReportClickHandler}/>
                </ActionBar>
            );
        }
    return(
        <EditorShell>
            <SentenceBatchView list={list} setList={setList} isOpen={isOpenBatchView} onCancelClickHandler={onBatchViewCancelClickHandler} path={path}/>
            {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
            <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
            <FilePreviewModal isOpen={selectedFile.url ? true : false} type={selectedFile.type} value={selectedFile.url} onDeleteClickHandler={onDeleteImageClickHandler} onCancelClickHandler={onFileModalCloseClickHandler}/>
            <EditorHeader>
                <div>
                    <EditorTitle>문장 등록</EditorTitle>
                    <EditorDesc>행을 추가하거나 일괄등록으로 여러 문장을 한 번에 넣을 수 있습니다. 이미지·음원은 선택 사항입니다.</EditorDesc>
                </div>
                <CountBadge>{list.length}개</CountBadge>
            </EditorHeader>
            <SentenceTable 
                list={list} 
                onAddClickHandler={onAddClickHandler} 
                onChangeHandler={onChangeHandler} 
                onSelectHandler={onSelectHandler} 
                selectedList={selectedList} 
                onSelectAllClickHandler={onSelectAllClickHandler} 
                onImageInputClickHandler={onImageInputClickHandler} 
                imageInputRefs={imageInputRefs} 
                onImageChangeHandler={onImageChangeHandler} 
                onFileClickHandler={onFileClickHandler} 
                audioInputRefs={audioInputRefs} 
                onAudioInputClickHandler={onAudioInputClickHandler} 
                onAudioChangeHandler={onAudioChangeHandler}
                onAudioDeleteHandler={onAudioDeleteHandler}
            />
            {renderButtons()}
        </EditorShell>
    )
}

export default SentenceView;